module.exports = __webpack_public_path__ + "img/next.feb73ef8.svg";